module.exports = __webpack_public_path__ + "static/media/title_doorhan.91977ead.jpg";